export interface CheckoutInstance {
  generateSessionState: (callback: (error: unknown, session?: string) => void) => void;
  clearForm: (callback: () => void) => void;
  remove: () => void;
}
interface WorldpaySdk {
  checkout: { init: (options: Record<string, unknown>, callback: (error: unknown, instance: CheckoutInstance) => void) => void };
}
const sources = {
  try: 'https://try.access.worldpay.com/access-checkout/v2/checkout.js',
  live: 'https://access.worldpay.com/access-checkout/v2/checkout.js',
};
let activeEnvironment: string | undefined;
let loading: Promise<WorldpaySdk> | undefined;
export function loadWorldpayCheckout(environment: 'try' | 'live'): Promise<WorldpaySdk> {
  if (activeEnvironment && activeEnvironment !== environment) {
    return Promise.reject(new Error('Worldpay environment changed. Reload the page before taking payment.'));
  }
  if (loading) return loading;
  activeEnvironment = environment;
  loading = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = sources[environment];
    script.async = true;
    const fail = () => {
      script.remove();
      loading = undefined;
      activeEnvironment = undefined;
      reject(new Error('Worldpay secure card fields could not load. Close and reopen this window to retry.'));
    };
    script.onerror = fail;
    script.onload = () => {
      const sdk = (window as Window & { Worldpay?: WorldpaySdk }).Worldpay;
      if (!sdk?.checkout?.init) { fail(); return; }
      resolve(sdk);
    };
    document.head.appendChild(script);
  });
  return loading;
}
